"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get the locale information from the Intl API.
 * @returns The locale string e.g. `en-US`.
 */
exports.default = () => Intl.DateTimeFormat().resolvedOptions().locale;
//# sourceMappingURL=getLocale.js.map